<template>
    <div class="detail-grade">
        <div class="lineBlock grade-item"
             v-for="(item, index) in gradeLevel"
             :style="{ backgroundColor: item.color }">
            <p class="grade-item-h" v-if="item.label">{{item.label}}<span>分</span></p>
            <p class="grade-item-t" :class="{'active': index === activeIndex}">{{item.title}}</p>
        </div>
        <span class="grade-index" :style="{left: offsetIndex + 'px'}"></span>
    </div>
</template>

<script>
    export default {
        props: ['score'],
        data() {
            return {
                gradeLevel: [
                    { title: '墓碑型', color: '#6aa3fa', min: 0, max: 59, label: '60' },
                    { title: '睡眠型', color: '#3c84f2', min: 60, max: 74, label: '75' },
                    { title: '保本型', color: '#2472e8', min: 75, max: 89, label: '90' },
                    { title: '赚钱型', color: '#1164e2', min: 90, max: 100 }
                ],
                blockWidth: 100,
                activeIndex: 0,
                offsetIndex: 0
            }
        },
        mounted() {
            this.blockWidth = this.$el ? this.$el.getElementsByClassName('grade-item')[0].offsetWidth : this.blockWidth;
            this.offsetIndex = this.blockWidth * this.gradeLevel.length - 8;
            this.computePosition(this.score);
        },
        watch: {
            score(newVal) {
                this.computePosition(newVal);
            }
        },
        methods: {
            computePosition(score) {
                let item, index = 0, width = this.blockWidth;
                for (let temp of this.gradeLevel) {
                    if (score >= temp.min && score <= temp.max) {
                        item = temp;
                        break;
                    }
                    index ++;
                }
                this.activeIndex = index;
                this.offsetIndex = ((score - item.min) / (item.max - item.min) * width - 8) + (index * width);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .detail-grade {
        position: relative;
        display: inline-block;
    }
    .grade-item {
        $height: 12px;
        position: relative;
        width: 100px;
        height: $height;
        text-align: center;
        border: 1px solid #fff;
        &:first-child {
            border-radius: $height / 2 0 0 $height / 2;
        }
        &:nth-child(4) {
            border-radius: 0 $height / 2 $height / 2 0;
        }
        .grade-item-h {
            position: absolute;
            top: -20px;
            right: -15px;
            font-size: 13px;
            color: #6b6b6b;
            margin: 0;
            span {
                font-size: 10px;
            }
        }
        .grade-item-t {
            font-size: 13px;
            color: #a9a9a9;
            margin: 16px 0 0;
            &.active {
                color: #000;
            }
        }
    }
    .grade-index {
        display: block;
        position: absolute;
        top: -2px;
        left: 0;
        width: 15px;
        height: 15px;
        border: 1px solid #bbb;
        background-color: #fff;
        border-radius: 50%;
        transition: left .5s ease;
    }
</style>


// WEBPACK FOOTER //
// app/view/detail/DetailGrade.vue